import React, { useCallback, useEffect, useMemo, useState } from 'react'

import { Button, InputNumber, message, Popconfirm, Select } from 'antd'
import R from 'ramda'
import { getApiTargetInfo } from 'core'
import {
  getUtilityNameMap,
  getUnitNameMap,
  getPermitActions,
  getEnvConfig,
} from 'core/selectors'
import UtilityUnitSelection from 'core/component/UtilityUnitSelection'

import moment from 'moment'
import { Label } from 'core/screen-util'
import { SppAcaUnitsCapabilityHeaders } from './ACAHeaders'
import {
  deleteunitCapability,
  getunitCapability,
  getUnitTypeInfoByUnit,
  postunitCapability,
} from './acaapi'
import { connect } from 'react-redux'
import CommonScreen from 'admin/component/CommonScreen'
import { hasAccesPermits } from 'core/utils'
import * as ScreenPermissions from 'core/EventActions'

const ACAReportUnitsCapability = props => {
  const [insertEvent, setInsertEvent] = useState(false)
  const [unitList, setUnitList] = useState([])

  useEffect(() => {
    getUnitTypeInfoByUnit(props.apiTargetInfo).fork(console.log, res => {
      setUnitList(res.map(ut => ut.unitId))
    })
  }, [props.apiTargetInfo])

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns:
            '150px 400px 70px 100px 100px 100px 100px 150px 150px 100px   150px 100px 150px',
          gap: 5,
        }}
      >
        <Label>Select Utility/Unit : </Label>
        <UtilityUnitSelection
          unitfilter={u => unitList.includes(u.unitId)}
          utility={insertData.utility}
          unit={insertData.unitId}
          onUnitChange={value => {
            // setUtilityUnit(value)
            setInsertData({
              ...insertData,
              utility: value[0],
              unit: value[1].substr(3),
              unitId: value[1],
            })
          }}
          casStyle={{ marginLeft: '5px' }}
        />

        <Label>Year :</Label>
        <Select
          value={insertData.year}
          style={{ width: 120 }}
          onChange={val => {
            setInsertData({ ...insertData, year: val })
          }}
        >
          {R.range(-15, 10).map(idx => {
            const y = moment().year() - idx
            return (
              <Select.Option key={y} value={y}>
                {y}
              </Select.Option>
            )
          })}
        </Select>
        <Label>Test Year :</Label>
        <Select
          value={insertData.testYear}
          style={{ width: 120 }}
          onChange={val => {
            setInsertData({ ...insertData, testYear: val })
          }}
        >
          {R.range(-15, 10).map(idx => {
            const y = moment().year() - idx
            return (
              <Select.Option key={y} value={y}>
                {y}
              </Select.Option>
            )
          })}
        </Select>

        <Label>Season :</Label>
        <Select
          // style={{ width: '150px' }}
          value={insertData.season}
          onChange={value => setInsertData({ ...insertData, season: value })}
        >
          <Select.Option value="Summer">Summer</Select.Option>
          <Select.Option value="Winter">Winter</Select.Option>
        </Select>
        <Label>Verified Capacity :</Label>
        <InputNumber
          value={insertData.verifiedCapacity}
          onChange={val =>
            setInsertData({ ...insertData, verifiedCapacity: val })
          }
        />

        <div style={{ gridColumnEnd: 'span 3' }}>
          <Button type="primary" onClick={() => onAdd(true)}>
            Add
          </Button>

          <Button
            type="primary"
            onClick={() => onAdd(false)}
            style={{ marginLeft: '20px' }}
          >
            Add & Hide
          </Button>
          <Button
            type="danger"
            onClick={onCancel}
            style={{ marginLeft: '20px' }}
          >
            Cancel
          </Button>
        </div>
      </div>
    )
  }

  const headerWithFormatter = useCallback(
    headers =>
      headers.map(header =>
        header.ident === 'utility' && header.isFormat
          ? {
              ...header,
              // ...toSelectionColProps(utilityNameMap),
              dataFormatter: ({ value }) =>
                value + ' - ' + (props.utilityNameMap[value] || value),
              sortIndexGetter: ({ rowData }) =>
                props.utilityNameMap[rowData.utility] || rowData.utility,
            }
          : header.ident === 'unitId'
          ? {
              ...header,
              // choices: [],
              dataFormatter: ({ value, rowData }) =>
                rowData.unit + ' - ' + (props.unitNameMap[value] || value),
              sortIndexGetter: ({ rowData }) =>
                props.unitNameMap[rowData.unitId] || rowData.unitId,
            }
          : header.ident === 'unitName'
          ? {
              ...header,
              // choices: [],
              dataFormatter: ({ rowData }) =>
                props.unitNameMap[rowData.unitId] || rowData.unitId,
              sortIndexGetter: ({ rowData }) =>
                props.unitNameMap[rowData.unitId] || rowData.unitId,
            }
          : header
      ),
    [props.unitNameMap, props.utilityNameMap]
  )

  const mainHeaders = useMemo(
    () => headerWithFormatter(SppAcaUnitsCapabilityHeaders),
    [headerWithFormatter]
  )

  const [year, setYear] = useState(moment().year())

  const screenCriteria = (s, p, u, onCriteriaChnage) => {
    return (
      <Select
        value={year}
        style={{ width: 120 }}
        onChange={val => {
          setYear(val)
          onCriteriaChnage({ year: val })
        }}
      >
        {R.range(-10, 10).map(idx => {
          const y = moment().year() - idx
          return (
            <Select.Option key={y} value={y}>
              {y}
            </Select.Option>
          )
        })}
      </Select>
    )
  }
  const withCriteria = _ => {
    return { year }
  }

  const extraCriteriaAfterButton = ({
    onRetrieve,
    isEditableAllowed,
    setSpinning,
    loading,
    data,
    apiTargetInfo,
    setError,
  }) => {
    if (!isEditableAllowed) return <div />
    return (
      <Popconfirm
        title="This action will delete all retrieved data. Do you want to continue?"
        okText="Yes"
        cancelText="No"
        onConfirm={() => {
          setSpinning(true)
          deleteunitCapability(apiTargetInfo)(data).fork(setError, _ => {
            setSpinning(false)
            message.success('Data removed successfully')
            onRetrieve()
          })
        }}
        // disabled={selected.selectedRows && selected.selectedRows.length <= 0}
        placement="topRight"
        // disabled
      >
        <Button
          loading={loading}
          icon="delete"
          style={{
            marginLeft: '10px',
            // color: '#FFFFFF',
            // backgroundColor: '#FF0000',
          }}
          type="danger"
          disabled={data.length <= 0}
        >
          Remove ALL
        </Button>
      </Popconfirm>
    )
  }
  const [withoutModify, setWithoutModify] = useState(true)

  useEffect(() => {
    const isAdmin = hasAccesPermits({
      actionPermits: props.permitActions,
      eventActions: [ScreenPermissions.AEP_ACA_SPP_DATA_WRITE],
      matchAny: true,
    })
    setWithoutModify(!isAdmin)
  }, [props.permitActions])

  return (
    <CommonScreen
      title="SPP Verified Capability"
      extraCriteriaAfterButton={extraCriteriaAfterButton}
      screenCriteria={screenCriteria}
      withCriteria={withCriteria}
      header={mainHeaders}
      initialSortOptions={SppAcaUnitsCapabilityHeaders}
      exportHeader={mainHeaders}
      saveTask={postunitCapability}
      retrieveTask={getunitCapability}
      deleteTask={deleteunitCapability}
      altBy={d => d.unitId}
      autoRetrieve
      insertComp={insertEvent && insertComp}
      insertCompHeight={90}
      onInsertEvent={b => setInsertEvent(b)}
      headerRowHeight={30}
      withImport
      importUrl="aepaca/unitCapability/import"
      importData={{ importType: 'ACAP_UNIT_CAPABILITY' }}
      defaultInsertData={{ year, testYear: year }}
      isAdminScreen={false}
      withoutModify={withoutModify}
      allowInsert={!withoutModify}
      // widthOffset={550}
      // heightOffset={100}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  permitActions: getPermitActions(state),
  envConfig: getEnvConfig(state),
})

export default connect(mapStateToProps)(ACAReportUnitsCapability)
